import { render, staticRenderFns } from "./PatrolQueue.vue?vue&type=template&id=1c8544e3&scoped=true"
import script from "./PatrolQueue.vue?vue&type=script&lang=ts"
export * from "./PatrolQueue.vue?vue&type=script&lang=ts"
import style0 from "./PatrolQueue.vue?vue&type=style&index=0&id=1c8544e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8544e3",
  null
  
)

export default component.exports